var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3327 31.9332V34.9999C68.3286 42.1879 66.001 49.1821 61.6971 54.9393C57.3932 60.6964 51.3436 64.9081 44.4505 66.9462C37.5575 68.9843 30.1902 68.7395 23.4476 66.2485C16.705 63.7574 10.9482 59.1535 7.03588 53.1234C3.12357 47.0933 1.26532 39.9601 1.73827 32.7876C2.21122 25.6151 4.99004 18.7876 9.66028 13.3234C14.3305 7.85927 20.642 4.05115 27.6533 2.46703C34.6647 0.882906 42.0002 1.60766 48.566 4.53321",
    stroke: "url(#paint0_linear_3060_125805)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3060_125805",
    x1: 34.9994,
    y1: 1.64746,
    x2: 34.9994,
    y2: 68.3141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8400",
    stopOpacity: 0.47
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinCircle);
export default __webpack_public_path__ + "static/media/spin-circle.546913b74ad485b5773c7b776645551b.svg";
export { ForwardRef as ReactComponent };